import { SET_TOKEN_DATA, SET_TOKEN_DATA2, SET_TOKEN_DATA1 } from "./types";
// please remove SET_TOKEN_DATA1 and  SET_TOKEN_DATA2 sonarLint issue
const initialState = {
  // giftToken
  gIsGiftTokenLoading: false,
  gPage: 1,
  gTotal: 0,
  giftTokenList: [],
  giftTokenRefetch: false,

  //giftTokenModal
  gIsGiftTokenModalOpen: false,
  gOrganisation: "",
  gToken: "",
  gIsGiftTokenModalLoading: false,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_TOKEN_DATA:
      return { ...state, ...action.payload };
    // please remove SET_TOKEN_DATA1 and  SET_TOKEN_DATA2 sonarLint issue
    case SET_TOKEN_DATA1:
      return { ...state, ...action.payload };
    case SET_TOKEN_DATA2:
      return { ...state, ...action.payload };

    default:
      return state;
  }
};
